import React from 'react';

const baseInput =
  'w-full border rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 transition-colors';

function fieldClasses({ error, valid, touched }) {
  if (touched && error) {
    return `${baseInput} border-red-300 focus:ring-red-400 focus:border-red-400`;
  }
  if (touched && valid) {
    return `${baseInput} border-green-400 focus:ring-green-500 focus:border-green-500`;
  }
  return `${baseInput} border-slate-300 focus:ring-teal-500 focus:border-teal-500`;
}

const FormField = ({
  id,
  label,
  hint,
  optional,
  type = 'text',
  value,
  onChange,
  onBlur,
  placeholder,
  autoFocus,
  error,
  valid,
  touched,
  inputMode,
  autoComplete,
  maxLength,
}) => (
  <div className="mb-5 last:mb-0">
    <label htmlFor={id} className="block text-sm font-medium text-slate-700 mb-1">
      {label}
      {optional && <span className="text-slate-400 font-normal"> (optional)</span>}
    </label>
    <input
      id={id}
      type={type}
      className={fieldClasses({ error, valid, touched })}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      placeholder={placeholder}
      autoFocus={autoFocus}
      inputMode={inputMode}
      autoComplete={autoComplete}
      maxLength={maxLength}
      aria-invalid={touched && Boolean(error)}
      aria-describedby={error ? `${id}-error` : hint ? `${id}-hint` : undefined}
    />
    {hint && !error && (
      <p id={`${id}-hint`} className="text-xs text-slate-500 mt-1.5">
        {hint}
      </p>
    )}
    {touched && error && (
      <p id={`${id}-error`} className="text-xs text-red-600 mt-1.5" role="alert">
        {error}
      </p>
    )}
    {touched && valid && !error && (
      <p className="text-xs text-green-700 mt-1.5">Looks good</p>
    )}
  </div>
);

export default FormField;
